module.exports = __webpack_public_path__ + "static/media/Iconfield05.2bf0c86b.svg";